<template>
    <v-container fluid>
        <v-card>
            <v-card-title>Armadi</v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col
                        ><v-btn color="primary" @click="addItem">
                            <v-icon> mdi-plus </v-icon> Nuovo
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-data-table
                            :headers="headers"
                            :items="arrRack"
                            item-key="id"
                            class="elevation-1"
                        >
                            <template v-slot:item.image="{ item }">
                                <a :href="item.image" target="_blank">
                                    <v-img
                                        height="100px"
                                        aspect-ratio="1"
                                        :src="item.image"
                                    ></v-img>
                                </a>
                            </template>
                            <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                            </template>
                            <template v-slot:item.families="{ item }">
                                <ul>
                                    <li
                                        class="small"
                                        v-for="fam in item.families"
                                        :key="fam.id"
                                    >
                                        {{ fam.acl_descla1 }}
                                    </li>
                                </ul>
                            </template>
                            <template v-slot:item.shops="{ item }">
                                <ul>
                                    <li
                                        class="small"
                                        v-for="shop in item.shops"
                                        :key="shop.id"
                                    >
                                        {{ shop.description }}
                                    </li>
                                </ul>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-row>
                                    <v-col>
                                        <v-icon small @click="editItem(item)">
                                            mdi-pencil
                                        </v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-icon small @click="copyRack(item)"
                                            >content_copy</v-icon
                                        >
                                    </v-col>
                                    <v-col>
                                        <v-icon small @click="deleteItem(item)">
                                            mdi-delete
                                        </v-icon>
                                    </v-col>
                                    <v-col>
                                        <v-btn
                                            :to="{
                                                name: 'cluster-list',
                                                params: { id: item.id },
                                            }"
                                            small
                                            outlined
                                            color="primary"
                                            depressed
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                            Clusters</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <create-modal-component
            ref="createModal"
            v-model:dialog="dialog"
            @saved="loadRacks"
        ></create-modal-component>
    </v-container>
</template>
<style lang="scss" scoped>
.small {
    font-size: 11px;
}
</style>
<script setup>
import CreateModalComponent from "./modals/CreateModalComponent.vue";
import requests from "../../requests";
import { ref } from "vue";
import _ from "lodash";

const headers = [
    { text: "Image", value: "image" },
    { text: "Data", value: "created_at" },
    { text: "Descrizione", value: "description" },
    { text: "Tipo", value: "rack_type.name" },
    { text: "Famiglie", value: "families" },
    { text: "Dim.", value: "size" },
    { text: "Negozi", value: "shops" },
    { text: "Action", value: "actions" },
];
const arrRack = ref([]);
const dialog = ref(false);
const rackData = ref({});
const createModal = ref(null);

function loadRacks() {
    requests.getRacks().then((response) => {
        arrRack.value = response.data;
    });
}
function addItem() {
    createModal.value.setRackData({});
    dialog.value = true;
}
function editItem(item) {
    createModal.value.setRackData(item);
    dialog.value = true;
}

function formatDate(date) {
    return new Date(date).toLocaleDateString();
}

function deleteItem(item) {
    if (window.confirm("Cancellare l'armadio?")) {
        requests.deleteRack(item.id).then(() => {
            loadRacks();
        });
    }
}

function copyRack(item) {
    if (window.confirm("Copiare l'armadio?")) {
        requests.copyRack(item.id).then(() => {
            loadRacks();
        });
    }
}

loadRacks();
</script>
